import { Validators } from '@angular/forms';
import * as fp from 'lodash/fp';

import { Option } from './option';
import { of } from 'rxjs';

export enum FieldType {
  Text,
  DDL,
  DateTime,
  Radio,
  Html,
  DateRange,
  DateTimeRange,
}

export enum TextFieldVariant {
  String,
  Integer,
  Float,
}

export class FieldModel {
  static fromAny = (fieldModel: any) =>
    new FieldModel(
      fieldModel.id,
      fieldModel.order,
      fieldModel.type,
      fieldModel.name,
      fieldModel.value,
      fieldModel.label,
      fieldModel.placeholder,

      fieldModel.creator,
      fieldModel.title,
      fieldModel.createdAt,

      fieldModel.isRead,

      fieldModel.textFieldType,
      (fieldModel.options || []).map((o: any) => Option.fromAny(o)),

      fieldModel.displayFormat,
      fieldModel.pickerFormat
    );

  constructor(
    public id: string,
    public order: number,
    public type: FieldType,
    public name: string,
    public value: string,
    public label: string,
    public placeholder: string,

    public creator: string,
    public title: string,
    public createdAt: Date,

    public isRead: boolean,

    public textFieldType: TextFieldVariant,
    public options: Array<Option>,

    public displayFormat: string,
    public pickerFormat: string
  ) {}

  get validators() {
    const validators = [];

    if (this.type === FieldType.Text) {
      validators.push(Validators.maxLength(150));

      switch (this.textFieldType) {
        case TextFieldVariant.String:
          break;
        case TextFieldVariant.Integer:
          validators.push(Validators.pattern(/^[-+]?\d+$/));
          break;
        case TextFieldVariant.Float:
          validators.push(Validators.pattern(/^[-+]?\d*\.?\d+$/));
          break;

        default:
          throw new Error('Not supported');
      }
    }

    return Validators.compose(validators);
  }

  get isNumeric() {
    return (
      this.type === FieldType.Text &&
      (this.textFieldType === TextFieldVariant.Integer ||
        this.textFieldType === TextFieldVariant.Float)
    );
  }

  get defaultValue() {
    switch (this.type) {
      case FieldType.Radio:
        return fp.get('[0].id', this.options);

      default:
        return this.value || '';
    }
  }

  toDDLModel = () => of({ options: this.options });
}
